<template>
  <pop-container :show="true">
    <div class="nologin-wrap no-px2rem" slot="content">
      <div class="login-btn" 
        v-lazy:background-image="lazyImgObj(config.imgUrl)" @click="handleLogin">
      </div>
      <div v-if="config.imgUrl && !loading" class="close-btn">
        <img src="https://img0.didiglobal.com/static/soda_static/m/act/static/img/close_icon.png" @click="handleHide()">
      </div>
    </div>
  </pop-container>
</template>
<script>
import PopContainer from '@/components/pop-container'
import trackEvent from '@/common/js/track'

export default {
  name: 'CouponNoLogin',
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      imgLoadingTime: 0, // 图片加载时间
      isImgLoaded: false // 图片是否已执行加载完成
    }
  },
  components: {
    PopContainer
  },
  async mounted () {
    this.imgLoadingTime = new Date().getTime()
    let globalParams = await this.SodaBridge('getGlobalParams', 'badcase') || {}
    const {osType, osVersion} = globalParams.data
    if (+osType === 2 && +osVersion.split('.')[0] < 6) { // 安卓 6.0 以下的系统无法监听到lazyload事件
      this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
    } else {
      this.$Lazyload.$on('loaded', async () => {
        if (!this.isImgLoaded) {
          this.$emit('onHideLoad', { imgLoadingTime: new Date().getTime() - this.imgLoadingTime })
        }
        this.isImgLoaded = true
      })
    }
    trackEvent({
      eventId: 'sailing_c_x_login_window_sw',
      eventLabel: '客户命中活动，展示登录页面',
      attrs: {
        activity_id: this.config.activityId
      }
    })
  },
  methods: {
    lazyImgObj (value) {
      return {
        src: value
      }
    },
    async handleHide () {
      trackEvent({
        eventId: 'sailing_c_x_login_window_close_ck',
        eventLabel: '客户命中活动，关闭登录页面',
        attrs: {
          activity_id: this.config.activityId
        }
      })
      this.$emit('onHide')
    },
    async handleLogin () {
      trackEvent({
        eventId: 'sailing_c_x_login_window_ck',
        eventLabel: '客户命中活动，登录页面点击去登录',
        attrs: {
          activity_id: this.config.activityId
        }
      })
      this.$emit('onLogin')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";
.nologin-wrap.no-px2rem {
  height: 440px;
  width: 268px;
  padding: 100px 10px 12px;
  .login-btn {
    width: 100%;
    display: block;
    height: 356px;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    button {
      border: none;
      width: 215px;
      height: 36px;
      @include bg-color();
      @include button-font-color();
      border-radius: 4px;
      margin-top: 280px;
    }
  }
  .close-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    img {
      width: 33px;
      height: 33px;
    }
  }
}
</style>